import Vue from 'vue'

import router from './router'
import store from './store'

import App from './App.vue'

//3rd Party
import VueLogger from 'vuejs-logger';
import VueCookie from 'vue-cookie';
import VeeValidate from 'vee-validate';
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import 'bootstrap';
import Toasted from 'vue-toasted';
import VueScrollTo from 'vue-scrollto';
import VueTheMask from 'vue-the-mask'
import VueFriendlyIframe from 'vue-friendly-iframe';
import * as VueGoogleMaps from 'vue2-google-maps'

//custom
import Toggle from "@/components/elements/vue-toggle.vue";
import Modal from "@/components/elements/vue-modal.vue";
import Block from "@/components/elements/vue-block.vue";
import { currency } from '@/filters/currency'
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";


const isProduction = process.env.NODE_ENV === 'production';

Vue.use(Toasted);
Vue.use(VueScrollTo)
Vue.use(VeeValidate, {
  events: 'change'
});
Vue.use(VueLogger, {
  isEnabled: !isProduction,
  showLogLevel : true,
  showMethodName : true,
  showConsoleColors: true
});
Vue.use(VueCookie);
Vue.use(VueTheMask)
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GA_API_KEY,
    libraries: "places,drawing,visualization",
    region: "ZA"
  },
  installComponents: true
});


//Filters
Vue.filter('currency', currency)

//Components
Vue.component('vue-friendly-iframe', VueFriendlyIframe);
Vue.component('v-select', vSelect);
Vue.component('vue-toggle', Toggle);
Vue.component('vue-modal', Modal);
Vue.component('vue-block', Block);
Vue.component('vue-loading', Loading);


Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)  
}).$mount('#app')

